// extracted by mini-css-extract-plugin
module.exports = {"topBar":"TopPanel_topBar__2HsWL","topBarTitle":"TopPanel_topBarTitle__TN0bt"};